import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Navbar } from '../layout/Navbar';
import { Footer } from '../layout/Footer';

export const ProfilePdfPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6 max-w-5xl">
          <div className="flex items-center gap-4 mb-6">
            <Button
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
              onClick={() => navigate('/')}
            >
              Back
            </Button>
            <h1 className="text-2xl md:text-3xl font-bold text-primary">PBAT Profile</h1>
          </div>

          <p className="text-gray-600 mb-6">
            Take a look at the PBAT profile document.
          </p>

          <div className="w-full rounded-xl border border-gray-200 overflow-hidden bg-gray-50">
            <iframe
              title="PBAT Profile PDF"
              src="/assets/PBAT%201_063806.pdf"
              className="w-full h-[80vh] md:h-[85vh]"
            />
          </div>

          <div className="mt-4 text-sm text-gray-500">
            If the PDF doesn’t render, your browser may be blocking it—use your browser’s PDF download/viewer.
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

